// extracted by mini-css-extract-plugin
export default {"wrapper":"SortableListItem_wrapper__YFdju","handle":"SortableListItem_handle__pPBWj","content":"SortableListItem_content__DX1BH"};